import React from 'react';
import {connect} from 'react-redux';
import {makeStyles} from '@material-ui/core/styles';
import {setFooterOpen, setScrollToElement} from '../../actions/app';
import {
    getGuestCheckout,
} from '../../actions/guestCheckout';
import loadable from "../../components/Lazy";
import {Box} from '@material-ui/core';
import GuestCheckoutPaymentPicker from "../../components/GuestCheckout/GuestCheckoutPaymentPicker";

const GuestCheckoutSummary = loadable(() =>
    import('../../components/GuestCheckout/GuestCheckoutSummary')
);
const Grid = loadable(() => import('@material-ui/core/Grid'));
const Container = loadable(() => import('@material-ui/core/Container'));
const useStyles = makeStyles((theme) => ({
    '@global': {
        body: {
            backgroundColor: theme.palette.grey[200],
        },
    },
    card: {
        marginBottom: theme.spacing(2),
    },
    textfield: {
        marginBottom: theme.spacing(1),
    },
    summaryContainer: {
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    optionWrapper: {
        display: 'flex',
        alignItems: 'center',
        minHeight: '100px',
        width: '100%',
    },
    optionCards: {
        width: '100%',
        // flexDirection: 'row',
        display: 'block'
    },
    mark: {
        display: 'block',
        marginBottom: theme.spacing(1)
        // alignItems: 'center',
        // flex: 1,
        // '&:first-of-type': {
        //     marginRight: 18,
        // },
    },
    payOption: {
        padding: '0 17px',
        border: '1px solid #D9E0E4',
        height: 50,
        width: '100%',
        borderRadius: '7px',
        margin: 0,
    },
    payOptionActive: {
        border: '1px solid #F26724',
    },
    cardElementContainer: {
        padding: '18.5px 14px',
        border: 'solid 2px #222222',
        borderRadius: '5px',
        marginBottom: `${theme.spacing(3)}px`
    }
}));

const SecureCheckoutPaymentRoute = ({
    setFooterOpen,
    guestCheckout,
    getGuestCheckout,
    setScrollToElement,
    savedPaymentMethods = {},
}) => {
    const classes = useStyles();


    React.useEffect(() => {
        setFooterOpen(true);
        getGuestCheckout();
        // eslint-disable-next-line
    }, []);

    React.useEffect(() => {
        if (!guestCheckout.idempotencyKey) {
             return;
        }
        if (guestCheckout.cartCount === 0) {
            window.location.href = '/cart';
        }
        if (!guestCheckout.paymentIntentClientSecret) {
            window.location.href = '/cart';
        }
    }, [guestCheckout])

    return (
        <>
            <Box mt={4} mb={10}>
                <Container maxWidth="md">
                    <Grid container spacing={2}>
                        <Grid xs={12} md={7} item>
                            <GuestCheckoutPaymentPicker
                                secureCheckout={true}
                                setScrollToElement={setScrollToElement}
                                guestCheckout={guestCheckout}
                                savedPaymentMethods={savedPaymentMethods}
                            />
                        </Grid>
                        <Grid xs={12} md={5} item className={classes.summaryContainer}>
                            <GuestCheckoutSummary
                                guestCheckout={guestCheckout}
                            />
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </>
    );
};

export default connect(
    (state) => ({
        guestCheckout: state.guestCheckout.guestCheckout,
    }),
    {
        setFooterOpen,
        getGuestCheckout,
        setScrollToElement
    }
)(SecureCheckoutPaymentRoute);
